export default __webpack_public_path__ + "static/media/banner.ce064c04.jpg";